import { CostCentersDistributionDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface CostCentersProps {
  applyingOn?: string
  resourceId: string
  resourceType: string
  skipQueries?: boolean
  includingAssignmentsFromAllocations?: boolean
}

const useCostCentersDistribution = ({
  resourceId,
  resourceType,
  skipQueries = false,
}: CostCentersProps) => {
  const { data, loading, refetch } = useQuery(CostCentersDistributionDocument, {
    variables: {
      resourceId,
      resourceType,
    },
    skip: skipQueries,
    fetchPolicy: 'no-cache',
  })

  const distribution = data?.costCenters.distributionsConnection.nodes || []

  return {
    isLoading: loading,
    distribution,
    refetch,
  }
}

export default useCostCentersDistribution
